import { Component, computed, input, output, inject, signal } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule, TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-sidebar',
  imports: [RouterLink, RouterLinkActive, MatIconModule, TranslateModule],
  templateUrl: './sidebar.component.html',
  styleUrl: './sidebar.component.scss',
})
export class SidebarComponent {
  private readonly translate = inject(TranslateService);

  userName = input<string>('Administrateur');
  userEmail = input<string>('admin@stef.com');
  logout = output<void>();

  currentLang = signal(this.translate.currentLang || 'fr');
  isLangMenuOpen = signal(false);

  availableLanguages = [
    { code: 'fr', label: 'Fran\u00e7ais' },
    { code: 'en', label: 'English' },
  ];

  userInitial = computed(() => {
    return this.userName().charAt(0).toUpperCase();
  });

  toggleLangMenu(): void {
    this.isLangMenuOpen.update((value) => !value);
  }

  switchLanguage(lang: string): void {
    this.translate.use(lang);
    this.currentLang.set(lang);
    this.isLangMenuOpen.set(false);
  }
}
